import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Rating from '@components/@core/Rating';
import Button from '@components/@core/AnimatedButton';
import AppActions from '~/actions/app';
import VendorActions from '~/actions/vendor';

const ProductRating = ({ className, data }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const loginUser = useSelector((state) => state.app.user?.community_user);

    const handleOpenRating = () => {
        const payload = {
            type: 'Rate Vendor',
            data: {
                before: { company: data?.parent_id, category: data?.data?.category, product: data?.id },
            },
        };
        if (loginUser?.id) {
            if (loginUser?.profile?.member_type !== 0) {
                toast.warn('Sorry, only dealers can leave reviews.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
            const after = { type: 'MODAL_REQUEST', payload };
            dispatch(VendorActions.getallvendorcompaniesRequest({ after }));
        } else {
            const route = `${location.pathname}${location.search}`;
            const after = { type: 'MODAL_REQUEST', payload };
            dispatch(
                AppActions.modalRequest({
                    type: 'Authentication',
                    data: { before: { route, after } },
                })
            );
        }
    };

    return (
        <div className={`product-rating ${className}`}>
            <p className="dsl-b18 bold">Ratings</p>
            {data?.stats?.rating_avg ? (
                <>
                    <div className="d-flex">
                        <Rating score={Math.round(Number(data?.stats?.rating_avg) * 100) / 100 || 0} size="medium" />
                    </div>
                    <p className="dsl-b18 bold product-rating_sub-heading m-0 mt-3">{Math.round(data.stats?.rating_recommended_avg * 100) / 100 || 0}% Recommended</p>
                </>
            ) : (
                <Button name="Leave first review" type="medium" onClick={handleOpenRating} />
            )}
            <p className="dsl-b14 m-0 mt-3">{data.stats?.rating_count} Verified Ratings</p>
            <p className="dsl-b14 m-0 mt-3">By {data.stats?.rating_dealership_count} Verified Dealership</p>
        </div>
    );
};

export default ProductRating;
